import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";
import apiRequest from "src/common/utils/apiRequest";
import coreFunctions from "src/common/utils/coreFunctions";

const firebaseConfig = {
  apiKey: "AIzaSyCPRx6LZf5CtJIzkIHMEY9uGKUcB2ged80",
  authDomain: "mts-erp-38629.firebaseapp.com",
  projectId: "mts-erp-38629",
  storageBucket: "mts-erp-38629.firebasestorage.app",
  messagingSenderId: "220445043040",
  appId: "1:220445043040:web:879325c61701509e301605",
  measurementId: "G-9V49Z523TN"
};

const app = initializeApp(firebaseConfig);

let messaging: ReturnType<typeof getMessaging> | null = null;

isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  } else {
    console.warn("Firebase messaging not supported in this browser.");
  }
});

const getFCMToken = async (): Promise<string | null> => {
  if (!messaging) return null;

  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BHr6qwOd0AVzdTXDp1SBFGceEPZb-4yqMzDctKeJMKpYTW6oHX63CbqL7em61TKTy1lnvGQ-PV_ukFrBewjtWO4",
    });

    return currentToken || null;
  } catch (error) {
    console.error("FCM Token error:", error);
    return null;
  }
};

const requestPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted")
      throw new Error("Notification permission not granted");

    const token = await getFCMToken();
    if (token) {
      const API_REQUEST = new apiRequest("save-fcm-token", true);
      await API_REQUEST.send({
        device_token: token,
        device: coreFunctions.isMobileDevice() ? "mobile" : "web",
      });
    }
  } catch (error) {
    console.error("🔴 FCM Init error:", error);
  }
};

export default requestPermission;
